module.exports = __webpack_public_path__ + "img/1250.2a762349.gif";